import React from "react"
import {Box} from "@mui/joy";
import {useUITheme} from "../hooks/useUITheme";

const Logo = () => {
    const uiTheme=useUITheme()
    return (<Box component={"img"}
                 width={48}
                 height={"auto"}
                 src={uiTheme.logo}
                 alt={'LinguaScore Logo'}
    />)
}

export default Logo